import { render, staticRenderFns } from "./CompensatoryService.vue?vue&type=template&id=cbb8e44e&scoped=true"
import script from "./CompensatoryService.vue?vue&type=script&lang=js"
export * from "./CompensatoryService.vue?vue&type=script&lang=js"
import style0 from "./CompensatoryService.vue?vue&type=style&index=0&id=cbb8e44e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb8e44e",
  null
  
)

export default component.exports